import { useState } from 'react';
import { KEODataFetchWrapper } from '../wrappers/KEODataFetchWrapper';
import { DataFetchFunction } from '../types/ProgressTypes';
import { EupType } from "../../model";

export const useKeoData = (onComplete?: () => void) => {
    const [showProgress, setShowProgress] = useState(false);
    const [fetchDataFunction, setFetchDataFunction] = useState<DataFetchFunction | null>(null);

    const fetchKeoData = (
        eupType: EupType,
        year: number,
        sheetName: string
    ) => {
        // Zapisz aktualną ścieżkę dla powrotu
        sessionStorage.setItem('keoReturnPath', location.pathname);

        const dataFetch = KEODataFetchWrapper.wrapKeoAnnualDataFetch(
            eupType,
            year,
            sheetName
        );
        setFetchDataFunction(() => dataFetch);
        setShowProgress(true);
    };

    const resetProgress = () => {
        setShowProgress(false);
        setFetchDataFunction(null);
    };

    const handleProgressComplete = (wasSuccess: boolean) => {
        resetProgress();
        // Wywołaj callback przekazany z komponentu rodzica tylko przy sukcesie
        if (wasSuccess && onComplete) {
            onComplete();
        }
    };

    return {
        showProgress,
        fetchDataFunction,
        fetchKeoData,
        resetProgress,
        handleProgressComplete,
        backTo: '/' // Nie jest już używany, ale zachowany dla kompatybilności
    };
};